import defaultTheme from "./default";

const palette = { ...defaultTheme.palette };
palette.primary = "hsla(205, 94%, 34%, 1)";

const theme = { ...defaultTheme, palette };

export default theme;
